import keyBy from 'lodash-es/keyBy';
import omit from 'lodash-es/omit';
import { ILink } from './linksInterfaces';
import { LinkActionKeys as keys } from './linksActionKeys';
import { LinkActionTypes } from './linksActionTypes';

export interface ILinksState {
  hash: { [index: number]: ILink };
  ids: number[];
}

const initState: ILinksState = {
  hash: {},
  ids: []
};

export function linksReducer(state: ILinksState = initState, action: LinkActionTypes): ILinksState {
  switch (action.type) {
    case keys.DETELTE_LINK_FULFILLED:
      return {
        ...state,
        hash: omit(state.hash, action.payload.linkId),
        ids: state.ids.filter(x => x !== action.payload.linkId)
      };
    case keys.SET_LINKS:
      return {
        ...state,
        hash: { ...state.hash, ...keyBy(action.payload, (x: ILink) => x.miaLinkId) },
        ids: action.payload.map<number>(x => x.miaLinkId)
      };
    default:
      return state;
  }
}
